import React from 'react';
import PropTypes from 'prop-types';

const GalleryItem = ({ item, index, onOpenModal }) => {
  const truncatePrompt = (text, maxLength = 80) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  return (
    <div
      className="gallery-item"
      data-aos="fade-up"
      data-aos-delay={index * 50}
      onClick={() => onOpenModal(item)}
      data-ratio={item.ratio}
      data-prompt={item.prompt}
    >
      <img src={item.src} alt={item.alt} loading="lazy" />
      <div className="info-tooltip">
        <div className="info-label">Aspect Ratio</div>
        <div className="info-value">{item.ratio}</div>
        <div className="info-prompt">{truncatePrompt(item.prompt)}</div>
      </div>
    </div>
  );
};

GalleryItem.propTypes = {
  item: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    ratio: PropTypes.string.isRequired,
    prompt: PropTypes.string.isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
  onOpenModal: PropTypes.func.isRequired,
};

export default GalleryItem;